import { render, staticRenderFns } from "./modify-person-info.vue?vue&type=template&id=6070e4b5&scoped=true&"
import script from "./modify-person-info.vue?vue&type=script&lang=js&"
export * from "./modify-person-info.vue?vue&type=script&lang=js&"
import style0 from "./modify-person-info.vue?vue&type=style&index=0&id=6070e4b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6070e4b5",
  null
  
)

export default component.exports